<template>
  <v-dialog
    v-model="dialog"
    :width="width"
    @click:outside="cancelPushed"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        append-icon="mdi-folder-lock"
        :clearable="clearable"
        readonly
        :label="txtLabel"
        :value="getValue"
        v-bind="attrs"
        v-on="on"
        @click:append="openDialog"
      />
    </template>
    <v-card>
      <v-card-title>
        {{ btnLabel }}
      </v-card-title>
      <v-card-text id="wrapper">
        <slot />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="okPushed"
        >
          {{ $t("dialog.ok") }}
        </v-btn>
        <v-btn
          text
          @click="cancelPushed"
        >
          {{ $t("dialog.cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    btnLabel: {
      type: String,
      required: true,
    },
    txtLabel: {
      type: String,
      required: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    width: {
      type: Number,
      default: 500,
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    getValue() {
      return this.value;
    },
  },
  methods: {
    cancelPushed() {
      this.dialog = false;
      this.$emit("cancel-pushed");
    },
    okPushed() {
      this.dialog = false;
      this.$emit("ok-pushed");
    },
    openDialog() {
      this.dialog = true;
    },
  },
};
</script>

<style>
#wrapper {
  max-height: 400px;
  overflow-y: auto;
}
</style>
